import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/_atoms/button";

interface TwoFactorQRCodeDisplayProps {
  otpAuthUrl: string;
  secret: string;
  accountName: string;
}

export function TwoFactorQRCodeDisplay({ otpAuthUrl, secret, accountName }: TwoFactorQRCodeDisplayProps) {
  const [showManualEntry, setShowManualEntry] = useState(false);
  const { t } = useTranslation("two-factor-auth");

  return (
    <div className="flex flex-col space-y-4">
      <div className="flex flex-col items-center space-y-4">
        <div className="rounded-md border bg-white p-4">
          <QRCodeSVG value={otpAuthUrl} size={256} level="M" />
        </div>
        <p className="text-center text-sm text-muted-foreground">
          {t("qrCode.scanDescription")}
        </p>
      </div>

      <div className="border-t pt-4">
        <Button
          type="button"
          variant="link"
          onClick={() => setShowManualEntry(!showManualEntry)}
          className="h-auto p-0"
        >
          {showManualEntry ? t("qrCode.hide") : t("qrCode.cannotScan")}
        </Button>

        {showManualEntry && (
          <div className="mt-4 rounded-md bg-muted p-4">
            <label className="mb-2 block text-xs text-foreground">{t("qrCode.secretKey")}</label>
            <div className="flex items-center space-x-2">
              <code className="flex-1 break-all rounded-md border bg-background px-3 py-2 font-mono text-sm">
                {secret}
              </code>
              <Button
                type="button"
                variant="outline"
                onClick={() => {
                  navigator.clipboard.writeText(secret);
                }}
              >
                {t("qrCode.copy")}
              </Button>
            </div>
            <p className="mt-2 text-xs text-muted-foreground">
              {t("qrCode.account")} <strong>{accountName}</strong>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
